import api from "./api";

export const createTeamMember = async (data) => {
  const res = await api.post("/admin/team", {
    name: data.name,
    category: data.category, // "leadership" or "membership"
    position: data.position,
    education: data.education,
    bio: data.bio,
    cv: data.cv,       // filename returned from upload
    photo: data.photo  // filename returned from upload
  });
  return res.data;
};

// Admin: get all team members
export const getAdminTeamMembers = async () => {
  const res = await api.get("/admin/team");
  return res.data;
};

// Admin: get team member by id
export const getAdminTeamMemberById = async (id) => {
  const res = await api.get(`/admin/team/${id}`);
  return res.data;
};

// Admin: update team member
export const updateTeamMember = async (id, data) => {
  const res = await api.put(`/admin/team/${id}`, {
    name: data.name,
    category: data.category,
    position: data.position,
    education: data.education,
    bio: data.bio,
    cv: data.cv,
    photo: data.photo
  });
  return res.data;
};

// Admin: delete team member
export const deleteTeamMember = async (id) => {
  await api.delete(`/admin/team/${id}`);
};

// Public: get all team members
export const getTeamMembers = async () => {
  const res = await api.get("/team");
  return res.data;
};

// Public: get team member by id
export const getTeamMemberById = async (id) => {
  const res = await api.get(`/team/${id}`);
  return res.data;
};
